export const thunkTypes = {
  LIST_ROUTE: `deliveries/listRoute`,
  START_ROUTE: `deliveries/startRoute`,
  GET_ACTIVATION_URL: `deliveries/getActivationUrl`,
};
